import xhrService from "../common/xhrService";
import handleRequestFail from "./handleRequestFail";
import handleRequestSuccess from "./handleRequestSuccess";

const RECAPTCHA_SITE_KEY = "6LcIhjEsAAAAAMShGTg5FCk-vsKVJ88Auqx31Dci";

const handleSubmit = (contactForm, e) => {
  e.preventDefault();
  contactForm.querySelector("button[type='submit']").setAttribute("disabled", "disabled");
  contactForm.querySelector("button[type='submit']").classList.add("loading");

  // reCAPTCHA v3 トークンを取得してから送信
  window.grecaptcha.ready(() => {
    window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "contact_submit" }).then((token) => {
      const data = {
        name: contactForm.querySelector("[name='name']").value,
        email: contactForm.querySelector("[name='email']").value,
        text: contactForm.querySelector("[name='text']").value,
        recaptchaToken: token,
      };

      xhrService(
        new XMLHttpRequest(),
        handleRequestSuccess(contactForm),
        handleRequestFail(contactForm),
        "POST",
        "https://vssau7haqf.execute-api.ap-northeast-1.amazonaws.com/Prod/",
        [{ key: "Content-Type", value: "application/json" }],
        data,
      );
    });
  });
};

export default handleSubmit;
